import React, {useEffect, createContext, useReducer} from 'react';
import { format } from 'date-fns';
import { FETCH_DATE_CONFIG,  SET_FROM_DATE, SET_UNTIL_DATE, DISPLAY_ERROR_MESSAGE, RESET_MODEL_AND_ERROR_FLAGS,
        SET_LOADING_FALSE, SET_IS_VALID_DATERANGE } from '../actions/actionTypes';
import { fetchMetaData } from '../actions/actionSelectors';
import { calendarReducer } from '../actions/calendar-reducer';

const initialState = {
    fromMinDate: undefined,
    fromRevenueDate: undefined,
    fromMaxDate: undefined,
    untilMinDate: undefined,
    untilRevenueDate: undefined,
    untilMaxDate: undefined,
    sessionTimeoutLimit: null,
    idleTimeoutLimit: null,
    errorMessage: "",   
    isError: false,
    modelHeaderTitle: null,
    showModel: false,
    isLoading : false,
    isValidDateRange: false
}
    
export const CalendarContext = createContext();

export function CalendarProvider(props) {

    const [state, dispatch] = useReducer(calendarReducer, initialState);
    const { fromMinDate, fromRevenueDate, fromMaxDate, untilMinDate, untilRevenueDate, untilMaxDate, 
            sessionTimeoutLimit, idleTimeoutLimit, isLoading, errorMessage, isError, isValidDateRange,
            modelHeaderTitle, showModel } = state;
    
    useEffect(() => {
        props.setSelectedNavItem(window.location.pathname.replace(/[/]/g, ''));   
        setIsLoading(true);     
        async function fetchMetaDataAsync() {
            await fetchMetaData()
                .then((data) => {
                    dispatch({
                        type: FETCH_DATE_CONFIG,
                        payload: {        
                            fromMinDate: data.FromMinDate,
                            fromMaxDate: data.FromMaxDate,
                            untilMinDate: data.ToMinDate,
                            untilMaxDate: data.ToMaxDate,                    
                            sessionTimeoutLimit: data.sessionTimeoutLimit ? +(data.sessionTimeoutLimit) : null,
                            idleTimeoutLimit: data.sessionTimeoutLimit ? +(data.idleTimeoutLimit) : null
                        }
                    });
                })
                .catch((error) => { errorOrWarningHandler(true, "wentwrong", true, "audit"); })
        }
        fetchMetaDataAsync();               
    }, []);  

    const resetSubmittedAndErrorFlags = () => {
        dispatch({ type: RESET_MODEL_AND_ERROR_FLAGS }); 
        props.setLogoutFalse();
    }  
    
    const setIsLoading = (flag) => { dispatch({ type: SET_LOADING_FALSE, payload: { isLoading : flag} }); }    
    
    const errorOrWarningHandler = (isModelError, errorModelMessage, showErrorModel, modelHeaderTitleError) => {
        dispatch({
            type: DISPLAY_ERROR_MESSAGE,
            payload: {
                isError: isModelError,
                errorMessage: errorModelMessage,                
                showModel: showErrorModel,
                modelHeaderTitle: modelHeaderTitleError              
            }
        });
    }   

    const fromDateHandler = (selectedDate, isFromDateError, errorFromDateMessage) => {
        if (isFromDateError)
            errorOrWarningHandler(isFromDateError, errorFromDateMessage, false, "audit");
        else
            dispatch({ type: SET_FROM_DATE, payload: { fromRevenueDate: format(selectedDate, "dd/MM/yyyy") } });
    }

    const untilDateHandler = (selectedDate, isUntilDateError, errorUmtilDateMessage) => {
        if (isUntilDateError)
            errorOrWarningHandler(isUntilDateError, errorUmtilDateMessage, false, "audit");
        else
            dispatch({ type: SET_UNTIL_DATE, payload: { untilRevenueDate: format(selectedDate, "dd/MM/yyyy") } });
    }

    const setIsValidDateRange = (isValidRange) => {
        dispatch({ type: SET_IS_VALID_DATERANGE, payload: { isValid : isValidRange} });
    }

    const provider = {
        fromMinDate,
        fromRevenueDate,
        fromMaxDate,
        untilMinDate,
        untilRevenueDate,
        untilMaxDate,
        sessionTimeoutLimit,
        idleTimeoutLimit,
        isLoading,
        errorMessage, 
        isError,
        modelHeaderTitle,
        isValidDateRange,
        showModel,
        fromDateHandler,
        untilDateHandler,
        resetSubmittedAndErrorFlags,        
        errorOrWarningHandler,
        setIsLoading,
        setIsValidDateRange
    };

    return (
        <CalendarContext.Provider value={provider}>
            {props.children}
        </CalendarContext.Provider>
    );
}
